import React from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import PageHeader from '../../components/common/PageHeader';
import PageTransition from '../../components/common/PageTransition';
import './Admin.css';

const adminTabs = [
  {
    to: '/admin/users',
    label: 'Members',
    icon: (
      <svg width="16" height="16" viewBox="0 0 20 20" fill="none">
        <path d="M10 10C12.2091 10 14 8.20914 14 6C14 3.79086 12.2091 2 10 2C7.79086 2 6 3.79086 6 6C6 8.20914 7.79086 10 10 10Z" stroke="currentColor" strokeWidth="1.5"/>
        <path d="M17 17C17 13.6863 13.866 11 10 11C6.13401 11 3 13.6863 3 17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      </svg>
    ),
  },
  {
    to: '/admin/tenants',
    label: 'Tenants',
    icon: (
      <svg width="16" height="16" viewBox="0 0 20 20" fill="none">
        <path d="M3 17V7L10 2L17 7V17H12V12H8V17H3Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
      </svg>
    ),
  },
  {
    to: '/admin/analytics',
    label: 'Analyse',
    icon: (
      <svg width="16" height="16" viewBox="0 0 20 20" fill="none">
        <path d="M3 17V10M8 17V6M13 17V3M18 17V8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      </svg>
    ),
  },
  {
    to: '/admin/audit',
    label: 'Audit Log',
    icon: (
      <svg width="16" height="16" viewBox="0 0 20 20" fill="none">
        <path d="M4 4H16M4 8H16M4 12H10M4 16H8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      </svg>
    ),
  },
  {
    to: '/admin/sharing',
    label: 'Sharing',
    icon: (
      <svg width="16" height="16" viewBox="0 0 20 20" fill="none">
        <circle cx="6" cy="10" r="2" stroke="currentColor" strokeWidth="1.5"/>
        <circle cx="14" cy="5" r="2" stroke="currentColor" strokeWidth="1.5"/>
        <circle cx="14" cy="15" r="2" stroke="currentColor" strokeWidth="1.5"/>
        <path d="M8 9L12 6M8 11L12 14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      </svg>
    ),
  },
  {
    to: '/admin/reference-library',
    label: 'Ref Library',
    icon: (
      <svg width="16" height="16" viewBox="0 0 20 20" fill="none">
        <path d="M10 4V17M10 4C8.83 3.48 7.25 3 5.5 3S2.17 3.48 1 4V17C2.17 16.48 3.75 16 5.5 16S8.83 16.48 10 17M10 4C11.17 3.48 12.75 3 14.5 3S17.83 3.48 19 4V17C17.83 16.48 16.25 16 14.5 16S11.17 16.48 10 17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
  },
  {
    to: '/admin/field-defaults',
    label: 'Field Defaults',
    icon: (
      <svg width="16" height="16" viewBox="0 0 20 20" fill="none">
        <path d="M10 2L3 6V10L10 14L17 10V6L10 2Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
        <path d="M3 10V14L10 18L17 14V10" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
      </svg>
    ),
  },
  {
    to: '/admin/security',
    label: 'Security',
    icon: (
      <svg width="16" height="16" viewBox="0 0 20 20" fill="none">
        <path d="M10 2L3 5V10C3 14.42 6.08 18.14 10 19C13.92 18.14 17 14.42 17 10V5L10 2Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
        <path d="M10 7V11M10 13.5V14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      </svg>
    ),
  },
  {
    to: '/admin/assay-types',
    label: 'Assay Types',
    icon: (
      <svg width="16" height="16" viewBox="0 0 20 20" fill="none">
        <path d="M7 2H13M8 2V7L3.5 15A2 2 0 005.24 18H14.76A2 2 0 0016.5 15L12 7V2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M5.5 13H14.5" stroke="currentColor" strokeWidth="1.5"/>
      </svg>
    ),
  },
  {
    to: '/admin/registration-rules',
    label: 'Registration',
    icon: (
      <svg width="16" height="16" viewBox="0 0 20 20" fill="none">
        <path d="M6 3H14C15.1 3 16 3.9 16 5V15C16 16.1 15.1 17 14 17H6C4.9 17 4 16.1 4 15V5C4 3.9 4.9 3 6 3Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
        <path d="M8 7H12M8 10H12M8 13H10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      </svg>
    ),
  },
  {
    to: '/admin/org-settings',
    label: 'Settings',
    icon: (
      <svg width="16" height="16" viewBox="0 0 20 20" fill="none">
        <circle cx="10" cy="10" r="3" stroke="currentColor" strokeWidth="1.5"/>
        <path d="M10 1V4M10 16V19M1 10H4M16 10H19M3.64 3.64L5.76 5.76M14.24 14.24L16.36 16.36M16.36 3.64L14.24 5.76M5.76 14.24L3.64 16.36" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      </svg>
    ),
  },
];

const AdminLayout: React.FC = () => {
  const location = useLocation();

  // Determine current tab label for breadcrumb
  const currentTab = adminTabs.find((tab) => location.pathname.startsWith(tab.to));

  return (
    <PageTransition>
      <PageHeader
        title="Administration"
        breadcrumbs={[
          { label: 'Admin' },
          ...(currentTab ? [{ label: currentTab.label }] : []),
        ]}
      />

      <div className="px-6 pb-6">
        {/* Horizontal tab navigation */}
        <nav className="admin-tabs">
          {adminTabs.map((tab) => (
            <NavLink
              key={tab.to}
              to={tab.to}
              className={({ isActive }) => `admin-tab ${isActive ? 'admin-tab--active' : ''}`}
            >
              {tab.icon}
              {tab.label}
            </NavLink>
          ))}
        </nav>

        {/* Content area */}
        <div className="admin-content">
          <Outlet />
        </div>
      </div>
    </PageTransition>
  );
};

export default AdminLayout;
